let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5bFnu")).then(() => parcelRequire('ihj3F'));